import { render, staticRenderFns } from "./InitialWorkflowDialog.vue?vue&type=template&id=161d8f61&scoped=true"
import script from "./InitialWorkflowDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./InitialWorkflowDialog.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "161d8f61",
  null
  
)

export default component.exports